; (function (jQuery) {

	"use strict";

	function Main() {
		var global = {
			navExpanded: false
		};

		var fn = {
			init: function ()
			{
				jQuery('.no-js').removeClass('no-js');

				fn.addColourWrap();

				window.onscroll = fn.navBarShrink;

				jQuery('.blog-filter-dropdown').on('change', fn.handleBlogFilter);

				jQuery('.faqs__question').on('click', fn.handleFAQExpansion);

				jQuery('.match-height').matchHeight();
				jQuery('.match-height-sub-1').matchHeight();
				jQuery('.match-height-sub-2').matchHeight();
				jQuery('.match-height-sub-3').matchHeight();
				jQuery('.match-height-sub-4').matchHeight();
				jQuery('.match-height').matchHeight(); // Repeated

				// Iframe responsive layouts
				jQuery('iframe').each(fn.wrapIframes);
				jQuery('.calculate-aspect-ratio').each(fn.calculateAspectRatio);

				// Number spinner - https://github.com/srexi/purecounterjs/
				new PureCounter();
			},


			// Adds span to specified links with ancester class of 'format-link-colour-wrap'.
			// Spans are activated on mouseover to show colour wrap
			addColourWrap: function()
			{
				jQuery('.format-link-colour-wrap a').wrapInner('<span></span>');
				jQuery('.format-link-colour-wrap a').on({
					'mouseover': function()
					{
						jQuery(this).find('span').addClass('inline-colour-wrap');
					},
					'mouseleave': function()
					{
						jQuery(this).find('span').removeClass('inline-colour-wrap');
					}
				})
			},

/*
			handleMenuExpansion: function()
			{
				var navBarMenu = jQuery('.nav-bar__menu');
				var navBarButton = jQuery('.nav-bar__menu-btn');
				var navBarMenuIcon = jQuery('.nav-bar__menu-icon');
				if (!global.navExpanded)
				{
					global.navExpanded = true;
					navBarMenu.addClass('nav-bar__menu--active');
					navBarButton.attr('aria-expanded', 'true');
					navBarMenuIcon.addClass('nav-bar__menu-icon--active');
				}
				else
				{
					global.navExpanded = false;
					navBarMenu.removeClass('nav-bar__menu--active');
					navBarButton.attr('aria-expanded', 'false');
					navBarMenuIcon.removeClass('nav-bar__menu-icon--active');
				}
			},
*/

			handleFAQExpansion: function()
			{
				var FAQItem = jQuery(this).closest('.faqs__item');
				var FAQAnswer = FAQItem.find('.faqs__answer');
				//var navBarMenuIcon = jQuery('.nav-bar__menu-icon');
				if (FAQItem.hasClass('faqs__item--open'))
				{
					FAQItem.removeClass('faqs__item--open');
					FAQAnswer.hide();
				}
				else
				{
					FAQItem.addClass('faqs__item--open');
					FAQAnswer.show();
				}
			},


			navBarShrink: function()
			{
				var navBar = jQuery('.nav');
				var scrollDistance = 100;
				if (document.body.scrollTop > scrollDistance || document.documentElement.scrollTop > scrollDistance)
				{
					navBar.addClass('nav--shrink');
				} else {
					navBar.removeClass('nav--shrink');
				}
			},


			handleBlogFilter: function()
			{
				var newCatID = jQuery(this).val();
				var blogRollURL = jQuery(this).data('blog-roll-url');
				if (newCatID > 0)
				{
					location.href = "/?cat=" + newCatID;
				}
				else
				{
					location.href = blogRollURL;
				}
			},

			// Responsive Videos & Google Maps
			// 1. Wrap any iframes with aspect ratio calculation div (if not already wrapped in templates)
			wrapIframes: function(i, iframe)
			{
				if (!jQuery(iframe).parent('.calculate-aspect-ratio').length)
				{
					//console.log('plop');
					jQuery(iframe).wrap('<div class="calculate-aspect-ratio"></div>');
				}
			},
			// 2. Calculate Aspect Ratio of iFramed content
			// Uses padding-bottom % to allow responsive iFrames
			calculateAspectRatio: function(i, container)
			{
				// Responsive Iframes
				var iframe = jQuery(container).find('iframe');
				if (iframe.length) {
					var height = iframe.attr('height');
					var width = iframe.attr('width');
					if (!isNaN(height) && !isNaN(width) && (+height + +width) > 0) {
						var ratio = height / width * 100;
						jQuery(container).css('padding-bottom', ratio + '%');
					}
				}
				// EU Cookie fix - Bosh Plugin - to prevent zero padding-bottom on iFrames
				var euCookie = jQuery(container).find('.eucookie');
				if (euCookie.length) {
					jQuery(container).css('padding-bottom', '180px');
				}
			},

		}

		jQuery(fn.init);
	}

	new Main();
})(jQuery);